module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "rt-autocomplete el-autocomplete",
    attrs: {
      "aria-expanded": _vm.suggestionVisible,
      "aria-owns": _vm.id,
      "aria-haspopup": "listbox",
      "role": "combobox"
    },
    on: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }, [_c('el-input', _vm._b({
    ref: "input",
    class: {
      'is-focus': _vm.activated
    },
    attrs: {
      "clearable": false
    },
    on: {
      "input": _vm.handleInput,
      "change": _vm.handleChange,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "clear": _vm.handleClear
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.highlight(_vm.highlightedIndex - 1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.highlight(_vm.highlightedIndex + 1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleKeyEnter.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        return _vm.close.apply(null, arguments)
      }]
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, 'el-input', [_vm.$props, _vm.$attrs], false), [(_vm.$slots.prepend) ? _c('template', {
    slot: "prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('template', {
    slot: "append"
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.prefix || _vm.$scopedSlots.prefix) ? _c('template', {
    slot: "prefix"
  }, [_vm._t("prefix")], 2) : _vm._e()], 2), _vm._v(" "), (!_vm.showClear && _vm.showSuffixIcon) ? _c('rt-icon', {
    staticClass: "rt-autocomplete-righticon",
    attrs: {
      "slot": "suffix",
      "color": _vm.SCSS_VARIABLES.COLOR_INFO,
      "name": "rt-base-record-lined"
    },
    slot: "suffix"
  }) : _vm._e(), _vm._v(" "), (_vm.showClear) ? _c('rt-icon', {
    staticClass: "rt-autocomplete-clearicon",
    style: (_vm.computedClearIconStyle),
    attrs: {
      "slot": "suffix",
      "color": _vm.SCSS_VARIABLES.COLOR_INFO,
      "name": "rt-base-close_fill"
    },
    on: {
      "click": _vm.handleClear
    },
    slot: "suffix"
  }) : _vm._e(), _vm._v(" "), _c('el-autocomplete-suggestions', {
    ref: "suggestions",
    class: [_vm.popperClass ? _vm.popperClass : ''],
    attrs: {
      "id": _vm.id,
      "popper-options": _vm.popperOptions,
      "append-to-body": _vm.popperAppendToBody,
      "placement": _vm.placement,
      "visible-arrow": ""
    }
  }, [(_vm.suggestions.length) ? _c('div', _vm._l((_vm.suggestions), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "rt-autocomplete-suggestion-item",
      class: {
        highlighted: _vm.highlightedIndex === index
      },
      attrs: {
        "id": (_vm.id + "-item-" + index),
        "aria-selected": _vm.highlightedIndex === index,
        "role": "option"
      },
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [(item[_vm.valueKey]) ? _vm._t("default", function() {
      return [_c('div', {
        staticClass: "rt-autocomplete-suggestion-item-label",
        domProps: {
          "innerHTML": _vm._s(_vm.highlightQueryString(item[_vm.valueKey]))
        }
      }), _vm._v(" "), (!_vm.hideOptionDesc && item[_vm.optionDescField]) ? [(typeof item[_vm.optionDescField] === 'string') ? _c('div', {
        staticClass: "rt-autocomplete-suggestion-item-desc"
      }, [_vm._v("\n              " + _vm._s(item[_vm.optionDescField]) + "\n            ")]) : _vm._l((item[_vm.optionDescField]), function(n, i) {
        return _c('div', {
          key: n.label + '-' + n.value + '-' + i,
          staticClass: "rt-autocomplete-suggestion-item-desc"
        }, [_vm._v("\n                " + _vm._s(n.label + ': ' + n.value) + "\n              ")])
      })] : _vm._e()]
    }, {
      "item": item,
      "index": index
    }) : _vm._e()], 2)
  }), 0) : (!_vm.loading && !_vm.suggestions.length && _vm.fetchSuggestions) ? _c('rt-default-image', {
    attrs: {
      "text": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_vm._v("\n        " + _vm._s(_vm.$tx(("未找到" + (_vm.rtFormItem.label)), 'xpc.common.notFound', {
    label: _vm.rtFormItem.label
  })) + "\n      ")])]) : (!_vm.fetchSuggestions && _vm.currentValue) ? _c('rt-default-image', {
    attrs: {
      "text": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_vm._v("\n        " + _vm._s(_vm.$tx('暂无数据', 'xpc.defaultImage.noData')) + "\n      ")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f144077"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/autocomplete/src/autocomplete.vue
// module id = 2157
// module chunks = 137